var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6872 7H12.3128C9.37861 7 7 9.37265 7 12.2995V48.9505C7 51.8773 9.37861 54.25 12.3128 54.25H43.6872C46.6214 54.25 49 51.8773 49 48.9505V12.2995C49 9.37265 46.6214 7 43.6872 7Z",
    fill: "#43C04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.22393V12.0345C14 15.0482 16.3216 17.5 19.1751 17.5H36.8249C39.6785 17.5 42 15.0481 42 12.0345V7.22393C42 7.14877 41.9975 7.07428 41.9947 7H14.0054C14.0026 7.07428 14 7.14877 14 7.22393Z",
    fill: "#30A83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8734 12.25H14.1265C13.0901 12.25 12.25 13.0973 12.25 14.1423V47.1077C12.25 48.1528 13.0902 49 14.1265 49H41.8735C42.9099 49 43.75 48.1528 43.75 47.1077V14.1423C43.75 13.0972 42.9098 12.25 41.8734 12.25Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7884 12.25H14.2113C14.1398 12.25 14.0694 12.2556 14 12.2645C14.2796 15.2036 16.4848 17.5 19.1559 17.5H36.8441C39.5152 17.5 41.7204 15.2036 42 12.2645C41.9303 12.2556 41.8601 12.25 41.7884 12.25Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.954 5.23105H32.7369C32.2743 5.23105 31.8765 4.9374 31.7837 4.52896C31.4233 2.94298 29.8661 1.75 27.9999 1.75C26.1337 1.75 24.5766 2.94298 24.2162 4.52886C24.1234 4.9373 23.7256 5.23094 23.2629 5.23094H18.0458C16.7779 5.23094 15.7499 6.1574 15.7499 7.30016V11.9308C15.7499 13.0735 16.7779 14 18.0458 14H37.954C39.222 14 40.2499 13.0735 40.2499 11.9308V7.30027C40.2499 6.1574 39.222 5.23105 37.954 5.23105Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6249,
    y: 21,
    width: 22.75,
    height: 3.49999,
    rx: 1.75,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6249,
    y: 27.125,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6249,
    y: 33.25,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6249,
    y: 39.375,
    width: 15.75,
    height: 3.5,
    rx: 1.75,
    fill: "#4674B9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSection);
export default __webpack_public_path__ + "static/media/test_section.5e0b5723ae4c32ff17446113fc5805d0.svg";
export { ForwardRef as ReactComponent };